module.exports = __webpack_public_path__ + "static/media/image1.3ebf4638.webp";